import React from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';

/**
 * Visual performance indicators component
 * Displays color-coded icons based on gym performance metrics
 * Red = problems, Green = excellent, Nothing = normal
 */
export function PerformanceIndicators({ indicators }) {
  if (!indicators) {
    return null;
  }

  const { problems, excellent } = indicators;

  // Problem indicators take priority
  if (problems && problems.length > 0) {
    const problemMessages = {
      missing_pulses: 'Missing pulses',
      low_connect_rate: 'Low connect rate (<40%)',
      zero_closures: 'Zero closures with activity',
      no_fd: 'No front desk availability'
    };

    const tooltipText = problems.map(p => problemMessages[p] || p).join(', ');

    return (
      <div className="flex items-center justify-center" title={tooltipText}>
        <AlertCircle className="w-4 h-4 text-red-600" />
      </div>
    );
  }

  // Excellent performance indicators
  if (excellent && excellent.length > 0) {
    const excellentMessages = {
      all_pulses_filled: 'All pulses filled',
      high_connect_rate: 'High connect rate (>70%)',
      exceeds_target: 'Exceeds closure target'
    };

    const tooltipText = excellent.map(e => excellentMessages[e] || e).join(', ');

    return (
      <div className="flex items-center justify-center" title={tooltipText}>
        <CheckCircle className="w-4 h-4 text-green-600" />
      </div>
    );
  }

  // Normal performance - no icon
  return null;
}
